import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: 'df054d84-626c-4c80-9657-659c6a7a7d94',
        authority: "https://login.microsoftonline.com/245ed2ed-ed88-4f76-bcb5-6ec006bb68ed",
        redirectUri: window.location.origin,
        //  navigateToLoginRequestUrl: false
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);